import React, { useEffect, useState, useMemo } from "react";
import {
  Modal,
  Typography,
  Row,
  Col,
  Tabs,
  Button,
  Empty,
  Space,
  message,
  Input,
  Form,
  Select,
  DatePicker,
  Card,
  Alert,
  Table,
  theme,
  Flex,
  Tag
} from "antd";
import {
  useCancelUsimOrdersMutation,
  useUpdateUsimOrderStatusMutation,
  usePutUsimOrdersMutation,
  usePostUsimRechargeMutation,
  usePostReqUsimOrderDetailMutation,
  usePostUsimRechargeStatusMutation
} from "../../../api/usim/orders/UsimOrdersApi";
import { ExclamationCircleOutlined, LoadingOutlined, WarningOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import {
  useGetProductPlansQuery
} from "../../../api/usim/uploads/products/productPlansApi";
import { useGetProductTypesQuery } from "../../../api/usim/uploads/products/productTypeApi";
import { UsimOrderItemData, UpdateLogItem } from "../../../api/usim/orders/UsimOrderItem";
import { Auth } from "aws-amplify";
import { fromUSimStatus, toUSimStatus, USimStatus, USimStatusLabel, USimStatusOptions } from "./usimUtils";
// Define which fields can be edited based on order status
const EDITABLE_FIELDS_BY_STATUS: Record<string, string[]> = {
  "PENDING-ACTIVATION": ["iccid", "mobileNumber", "productType", "sku", "status", "activationDate"],
  "PENDING-RECHARGE": ["iccid", "mobileNumber", "productType", "sku", "status", "activationDate"],
  "COMPLETED-ACTIVATION-SUBMITTED": ["status", "activationDate"],
  "CANCELLED": [],
  "COMPLETED": []
};

// Define which statuses allow order cancellation
const NON_CANCELLABLE_STATUSES: any = [];

const { Text, Title } = Typography;


interface ProductDetail {
  planName: string;
  iccid: string;
  mobileNumber: string;
  productType: string;
  status: string;
  activationDate?: string;
  processedBy: string;
}
interface OrderDetailModalProps {
  isVisible: boolean;
  onClose: () => void;
  orderData: UsimOrderItemData | null;
  onOrderCancelled?: () => void;
}

const statusOptions = [
  { label: USimStatusLabel[USimStatus.PENDING_PROCESSING], value: USimStatus.PENDING_PROCESSING },
  { label: USimStatusLabel[USimStatus.COMPLETE], value: USimStatus.COMPLETE }
];

const simStatusJoytel: Record<string, string> = {
  "10": "plan recharged on sim but not activated",
  "11": "activated and should use usage",
  "12": "plan expired but sim still reusable",
  "13": "sim not reusable",
}

const S3_BASE_URL_PROD = "https://redemption-kyc-upload-20250701151105789600000001.s3.ap-southeast-1.amazonaws.com/";
const S3_BASE_URL_DEV = "https://redemption-kyc-upload-20250416021825824600000001.s3.ap-southeast-1.amazonaws.com/"

const isProduction = process.env.NODE_ENV === "production" || process.env.VERCEL_ENV === "production";
const KYC_MEDIA_URL = isProduction ? S3_BASE_URL_PROD : S3_BASE_URL_DEV;
export default function OrderDetailModal({
  isVisible,
  onClose,
  orderData,
  onOrderCancelled
}: OrderDetailModalProps) {
  const [form] = Form.useForm();
  const [cancelOrder, { isLoading: isCancelling }] = useCancelUsimOrdersMutation();
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [updateStatus, setUpdateStatus] = useState<string>("");
  const [updateDescription, setUpdateDescription] = useState<string>("");
  const [updateActivationDate, setUpdateActivationDate] = useState<any>(null);
  const [selectedProduct, setSelectedProduct] = useState<ProductDetail | null>(null);
  const [triggerUpdateStatus, { isLoading: isUpdating }] = useUpdateUsimOrderStatusMutation();
  const [putUsimOrders, { isLoading: isUpdatingOrder }] = usePutUsimOrdersMutation();
  const [cancelAction, setCancelAction] = useState<string>("cancel");
  const [currentTab, setCurrentTab] = useState<string>("orderDetails");
  const [formData, setFormData] = useState<any>(null);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [rechargeLoading, setRechargeLoading] = useState(false);

  const hasRechargeData = useMemo(() => {
    const autoRecharge = orderData?.autoRecharge as any;
    if (!autoRecharge) return false;
    if (Array.isArray(autoRecharge)) {
      return autoRecharge.length > 0;
    }
    return Object.keys(autoRecharge).length > 0;
  }, [orderData]);

  const isRechargeSuccess = useMemo(() => {
    const autoRecharge = orderData?.autoRecharge as any;
    if (!autoRecharge) return false;

    const isElite = orderData?.sku?.startsWith('elite');
    if (Array.isArray(autoRecharge)) {
      if (isElite) {
        return autoRecharge.some((item: any) => item.Status == 1 || item.status == 1);
      } else {
        return autoRecharge.some((item: any) => item.message === "SUCCESS" || item.code == 0 || item.code === "0" || item.Message === "SUCCESS");
      }
    } else {
      if (isElite) {
        return autoRecharge.Status == 1 || autoRecharge.status == 1;
      } else {
        return autoRecharge.message === "SUCCESS" || autoRecharge.code == 0 || autoRecharge.code === "0" || autoRecharge.Message === "SUCCESS";
      }
    }
  }, [orderData]);
  const [rechargeStatusLoading, setRechargeStatusLoading] = useState(false);
  const [mappingDetail, setMappingDetail] = useState<any>({});
  const [messageApi, contextHolder] = message.useMessage();
  let uploadedFile = ""
  // Initialize form data when orderData changes
  useEffect(() => {
    console.log("loaded order data")
   
    if (orderData) {

      let activationDate = null;
      if (orderData.activationDate) {
        const parsedDate = dayjs(orderData.activationDate);
        activationDate = parsedDate.isValid() ? parsedDate : null;
      }

      if (orderData.hasOwnProperty("sku")) {
        console.log("has sku")
        if (orderData.activationDate) {
          const parsed = dayjs(orderData.activationDate);
          activationDate = parsed.isValid() ? parsed : null;
        }

         if ( Object.keys(mappingDetail).length == 0) {
          getMappingDetails(orderData);
    }
      }
      else {
        console.log("does not have sku")
        // alert("Order does not have sku")
      }
      console.log('activation,date', activationDate)
      setUpdateActivationDate(dayjs(activationDate))
      setFormData({
        iccid: orderData.iccid,
        mobileNumber: orderData.mobileNumber,
        type: orderData.type,
        sku: orderData.sku,
        status: orderData.status,
        activationDate: activationDate
      });
    }
  }, [orderData]);

  // Only fetch product types and plans when editing is enabled
  const { data: productTypes } = useGetProductTypesQuery(undefined, {
    skip: !editMode
  });
  const { data: productPlans } = useGetProductPlansQuery(undefined, {
    skip: !editMode
  });

  const [postReqUsimOrderDetail, { isLoading: isProcessingOrderDetail }] = usePostReqUsimOrderDetailMutation();


  const [processRechargeApi, { isLoading: isProcessingRecharge }] = usePostUsimRechargeMutation();
  const [processRechargeStatusApi, { isLoading: isProcessingRechargeStatus }] = usePostUsimRechargeStatusMutation();

  const productTypesOptions = React.useMemo(() => {
    if (!productTypes) return [];
    return productTypes
      .filter(item => item.status == false)
      .map(item => ({
        label: item.name,
        value: item.name,
      }));
  }, [productTypes]);

  const productPlansOptions = React.useMemo(() => {
    if (!productPlans) return [];
    return productPlans
      .filter(item => item.status !== "INACTIVE")
      .map(item => ({
        label: item.planName,
        value: item.planName,
        type: item.type
      }));
  }, [productPlans]);

  const isFieldEditable = (fieldName: string, status: string) => {

    const editableFields = EDITABLE_FIELDS_BY_STATUS[status.toUpperCase()] || [];
    console.log("editable", editableFields)
    return editMode && editableFields.includes(fieldName);
  };

  const handleUpdateProducts = async () => {
    try {
      // TODO: Implement update logic here
      let session = await Auth.currentUserInfo();

      await putUsimOrders({
        OrderNumber: orderData!.OrderNumber,
        iccid: formData.iccid,
        mobileNumber: formData.mobileNumber,
        type: formData.type,
        sku: formData.planName,
        status: formData.status,
        activationDate: formData.activationDate ? dayjs(formData.activationDate).format('YYYY-MM-DD') : undefined,
        processedBy: session.username || "-",

      }).unwrap();
      message.success('Products updated successfully');
      setEditMode(false);
    } catch (error) {
      console.error('Error updating products:', error);
      message.error('Failed to update products');
    }
  };

  const handleEditOrder = () => {
    setEditMode(true);
  };

  const handleUpdateOrder = async () => {
    try {
      await handleUpdateProducts();
      setEditMode(false);
    } catch (error) {
      console.error('Error updating order:', error);
      message.error('Failed to update order');
    }
  };

  const getMappingDetails = async(orderData : UsimOrderItemData) => {
      try{
         const mapping_response = await postReqUsimOrderDetail({ orderNumber: orderData!.OrderNumber, shopId: orderData!.shopId }).unwrap();
     console.log("mapping response", mapping_response)
        setMappingDetail(mapping_response);
      }
      catch(error){
        console.log("error in fetching mapping details", error)
      }
  }
  const handleCancelOrder = async () => {
    if (!orderData) return;
    try {
      await cancelOrder({ orderNumber: orderData.OrderNumber, ShopId: orderData.shopId, action: cancelAction }).unwrap();
      message.success(`Order ${orderData.OrderNumber} has been cancelled successfully`);
      if (onOrderCancelled) {
        onOrderCancelled();
      }
      setShowCancelConfirm(false);
      onClose();
    } catch (error) {
      console.error("Error cancelling order:", error);
      message.error("Failed to cancel order. Please try again.");
    }
  };

   async function handleDownloadFile(url: string) {
    try {
      console.log("url", url)
      const res = await fetch(url);
      const buf = await res.arrayBuffer();
      const durl = window.URL.createObjectURL(new Blob([buf]));
      const ln = document.createElement("a");
      const parts = url.split(".");
      const ext = parts[parts.length - 1];
      const fn = orderData!!.OrderNumber + " Passport Photo." + ext;
      ln.href = durl;
      ln.setAttribute("download", fn);
      document.body.appendChild(ln);
      ln.click();
    } catch (ex) {
      messageApi.error("Error creating download link");
      console.error("Error creating download link");
      console.error(ex);
    }
  }
  const showUpdateStatusModal = (product: ProductDetail) => {
    setSelectedProduct(product);
    setUpdateActivationDate(product.activationDate ? dayjs(product.activationDate) : null);
    setUpdateStatus(product.status ? toUSimStatus(product.status) : USimStatus.PENDING_PROCESSING);
    setUpdateDescription("");
    setIsUpdateModalVisible(true);
  };

  const handleStatusUpdate = async () => {
    if (!orderData || !selectedProduct) return;

    try {
      let session = await Auth.currentUserInfo();
      await triggerUpdateStatus({
        id: orderData.OrderNumber,
        shopId: orderData.shopId,
        status: updateStatus,
        activationDate: dayjs(updateActivationDate).format('YYYY-MM-DD'),
        processedBy: session.username || "-",
        comment: updateDescription,
      }).unwrap();

      message.success("Status updated successfully");
      setIsUpdateModalVisible(false);
      setSelectedProduct(null);
      setUpdateDescription("");
      onClose(); // Refresh the modal data
    } catch (error) {
      message.error("Failed to update status");
    }
  };

  const handleRechargeNow = async (orderData: UsimOrderItemData) => {
    setRechargeLoading(true)
    if (!orderData) return;
    try {
      // if (orderData?.autoRecharge?.message == "SUCCESS") {
      //   message.error("Topup already done");
      //   return;
      // }
      console.log("order data,", orderData.OrderNumber)
      var response = await processRechargeApi({
        orderNumber: orderData.OrderNumber,
        shopId: orderData.shopId,
      }).unwrap();
      // delay 3 second
      // await new Promise((resolve) => setTimeout(resolve, 3000));
      console.log("response", response)
      message.success("Recharge now request sent successfully");
      // onClose(); // Refresh the modal data
    } catch (error) {
      message.error("Failed to send recharge now request");
    }
    finally{
      setRechargeLoading(false)
    }
  };
  const handleRechargeStatus = async (orderData: UsimOrderItemData) => {
    setRechargeStatusLoading(true)

    if (!orderData.orderTid) return;
    try {
      // if (orderData?.autoRecharge?.message == "SUCCESS") {
      //   message.error("Topup already done");
      //   return;
      // }
      //  await new Promise((resolve) => setTimeout(resolve, 3000));

      console.log("order data,", orderData.OrderNumber)
      var response = await processRechargeStatusApi({
        orderNumber: orderData.OrderNumber,
        shopId: orderData.shopId,
        orderTid: orderData.orderTid
      }).unwrap();
      // delay 3 second
     
      console.log("response", response)
      // message.success("Recharge now request sent successfully");
      // onClose(); // Refresh the modal data
    } catch (error) {
      message.error("Failed to get recharge status request");
    }
    finally{
      setRechargeStatusLoading(false)
    }
  };


  const renderOrderDetails = () => {
    if (!orderData) return <Empty description="No order data available" />;

    return (
      <div>
        <Form
          layout="vertical"
          form={form}
          initialValues={{
            orderNumber: orderData.OrderNumber,
            status: fromUSimStatus("10"),
            orderProcessedDate: orderData.orderProcessedDate ? dayjs(orderData.orderProcessedDate).format('DD-MM-YYYY HH:mm') : undefined,
            platform: orderData.orderData?.MarketplacePlatform || "Admin Portal",
            shopId: orderData.shopId,
            quantity: orderData.productDetails?.length || 0,
            email: orderData.orderData?.OrderDetails?.message_to_seller,
            amount: orderData.orderData?.OrderDetails?.amount,
            updatedAt: orderData.updated_at ? dayjs(orderData.updated_at).format('DD-MM-YYYY HH:mm') : undefined,
            processedBy: orderData.processedBy
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="orderNumber">
                <Input addonBefore="Order Number" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              {/* add space between the items in row */}
              <Row gutter={8} >
               <Col>
                <Form.Item name="status" style={{ marginRight: 8 }}>
                  <Input addonBefore="Status" readOnly />
                </Form.Item>
                </Col>
                <Button type="primary" onClick={() => showUpdateStatusModal({ planName: orderData.sku, status: orderData.status, iccid: orderData.iccid, mobileNumber: orderData.mobileNumber, productType: orderData.type, processedBy: orderData.processedBy, activationDate: orderData.activationDate })}>
                  Update
                </Button>
              </Row>
            </Col>
            <Col span={12}>
              <Form.Item name="orderProcessedDate">
                <Input addonBefore="Order Processed Date" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="platform">
                <Input addonBefore="Platform" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="shopId">
                <Input addonBefore="Shop ID" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="quantity">
                <Input addonBefore="Quantity" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="email">
                <Input addonBefore="Email" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="amount">
                <Input addonBefore="Amount" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="updatedAt">
                <Input addonBefore="updatedAt" readOnly />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="processedBy">
                <Input addonBefore="Processed By" readOnly />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {/* <div style={{ marginTop: 24 }}> */}
        {/* <Title level={5}>Products List</Title> */}
        {/* <Table
            columns={columns}
            dataSource={orderData.productDetails}
            rowKey="iccid"
            size="small"
            pagination={false}
          /> */}
        {/* </div> */}
      </div>
    );
  };

  const formatUsage = (bytes: number, unit: string) => {
    if (unit === "MB") {
      return (bytes / 1024 / 1024).toFixed(2) + " " + unit
    }

    return (bytes / 1024 / 1024 / 1024).toFixed(2) + " " + unit
  }

 

  const renderKycDetails = () => {
    if (!orderData) return null;
    
    const isAustralia = orderData.type?.toLowerCase().includes("australia");
      
    if (!isAustralia) return null;

    const handleCopy = (value: string | undefined, label: string) => {
      if (value) {
        navigator.clipboard.writeText(value);
        message.success(`${label} copied to clipboard`);
      }
    };

    return (
      <Card key={`kyc-${orderData?.OrderNumber}`} style={{ marginBottom: 12 }} title="KYC Details">
        {(!orderData?.kycDetails || Object.keys(orderData.kycDetails).length === 0) ? (
          <Text>Kyc Details not available</Text>
        ) : (
          <Form layout="vertical">
            {orderData.kycDetails.email && (
              <Row gutter={8} style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <Input
                    readOnly
                    addonBefore="Customer Email"
                    value={orderData.kycDetails.email}
                    onClick={() => handleCopy(orderData.kycDetails?.email, "Email")}
                    style={{ cursor: "pointer" }}
                  />
                </Col>
              </Row>
            )}
            <Row gutter={8} style={{ marginBottom: 8 }}>
              <Col span={12}>
                <Input
                  readOnly
                  addonBefore="Passport Number"
                  value={orderData.kycDetails.passportNumber}
                  onClick={() => handleCopy(orderData.kycDetails?.passportNumber, "Passport Number")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
              <Col span={12}>
                <Input
                  readOnly
                  addonBefore="Passport Country"
                  value={orderData.kycDetails.passportCountry}
                  onClick={() => handleCopy(orderData.kycDetails?.passportCountry, "Passport Country")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
            </Row>
            <Row gutter={8} style={{ marginBottom: 8 }}>
              <Col span={8}>
                <Input
                  readOnly
                  addonBefore="Given Name"
                  value={orderData.kycDetails.givenName}
                  onClick={() => handleCopy(orderData.kycDetails?.givenName, "Given Name")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
              <Col span={8}>
                <Input
                  readOnly
                  addonBefore="Middle Name (if any)"
                  value={orderData.kycDetails.middleName}
                  onClick={() => handleCopy(orderData.kycDetails?.middleName, "Middle Name")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
              <Col span={8}>
                <Input
                  readOnly
                  addonBefore="Surname"
                  value={orderData.kycDetails.surname}
                  onClick={() => handleCopy(orderData.kycDetails?.surname, "Surname")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
            </Row>
            <Row gutter={8} style={{ marginBottom: 8 }}>
              <Col span={12}>
                <Input
                  readOnly
                  addonBefore="Date of Birth"
                  value={orderData.kycDetails.dob ? dayjs(orderData.kycDetails.dob).format("DD-MMM-YYYY") : ""}
                  onClick={() => handleCopy(orderData.kycDetails?.dob ? dayjs(orderData.kycDetails.dob).format("DD-MMM-YYYY") : "", "Date of Birth")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
              <Col span={12}>
                <Input
                  readOnly
                  addonBefore="Arrival Date"
                  value={orderData.kycDetails.arrivalDate ? dayjs(orderData.kycDetails.arrivalDate).format("DD-MMM-YYYY") : ""}
                  onClick={() => handleCopy(orderData.kycDetails?.arrivalDate ? dayjs(orderData.kycDetails.arrivalDate).format("DD-MMM-YYYY") : "", "Arrival Date")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
            </Row>
            <Row gutter={8} style={{ marginBottom: 8 }}>
              <Col span={12}>
                <Input
                  readOnly
                  addonBefore="ICCID"
                  value={orderData.iccid}
                  onClick={() => handleCopy(orderData.iccid, "ICCID")}
                  style={{ cursor: "pointer" }}
                />
              </Col>
            </Row>

                <Flex gap={8} style={{marginTop: 8}}>
                      <Input 
                        readOnly
                        addonBefore="Upload"
                        value={`${KYC_MEDIA_URL} + ${orderData.kycDetails?.passportPhoto ?? "-"}`}
                      />
                      <Button
                        type="primary"
                        onClick={() => orderData.kycDetails?.passportPhoto && (
                        handleDownloadFile(KYC_MEDIA_URL + orderData.kycDetails?.passportPhoto))}
                      disabled={!orderData.kycDetails?.passportPhoto}
                      >
                        Download
                      </Button>
                      <Button
                        onClick={() => window.open(KYC_MEDIA_URL + orderData.kycDetails?.passportPhoto)}
                        disabled={!orderData.kycDetails?.passportPhoto}
                      >
                        Open
                      </Button>
                    </Flex>
          </Form>
        )}
      </Card>
    );
  };

  // recharge info contains
  // 1. sim card status 
  // 2. recharge information
  // 3. data usage
  const renderRechargeInfo = () => {
    console.log("odr", orderData)
    // if (orderData?.sku && !orderData?.sku?.startsWith("joy")) {
    //   return <Empty description="Only Joytel Products have recharge info" />;
    // }
    if (!orderData?.sku) {
      return (
        <Empty description="Only Joytel Products have recharge info" />
      )
    }

    const isAustralia = orderData.type?.toLowerCase().includes("australia");
    console.log(dayjs(1765443048000).format('DD-MM-YY HH:mm:ss'))

    return (
      <div>
        <div style={{ maxHeight: '600px', overflow: 'auto' }}>
           <Card
            key={orderData?.OrderNumber}
            style={{ marginBottom: 12 }}

          >
            <Form layout="vertical">
              <Row gutter={8} style={{ marginBottom: 16 }} >
                <Col span={20}>
                  <Input
                    readOnly
                    addonBefore="Status Page Link"
                    value={orderData.OrderNumber ? `https://usim.sim-ply.io/status/${orderData.OrderNumber}` : "N/A"}
                  /></Col>
                <Col span={4}>
                  <Button type="primary" onClick={() => window.open(`https://usim.sim-ply.io/status/${orderData.OrderNumber}`)}>
                    Open Status Page
                  </Button></Col>

              </Row>  
              {!isAustralia && (<Row gutter={16}>
                <Col span={12}>
                  <Row gutter={16} > 
                  <Col span={12}>
                     <Button className="mb-4" type="primary"  loading={rechargeLoading} onClick={() => handleRechargeNow(orderData)}>
                    {rechargeLoading ? "Recharging..." :  "Recharge Now"}
                  </Button>
                  </Col>
                   <Col>
                   <Button className="mb-4" type="primary" loading={rechargeStatusLoading} onClick={() => handleRechargeStatus(orderData)}>
                    check recharge status
                  </Button>
                  </Col>
                  </Row>
                  <Title level={5} style={{ margin: 0, paddingTop: 8, paddingBottom: 8 }}>Status Info</Title>

                  <div style={{ marginBottom: 8 }}>
                    <Input
                      readOnly
                      addonBefore="Sim Status"
                      value={orderData.vendorStatus?.data?.simStatus ? simStatusJoytel[orderData.vendorStatus?.data?.simStatus.toString()] : "N/A"}
                    />



                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input
                      readOnly
                      addonBefore="Status Updated at"
                      value={orderData.vendorStatus?.data?.simStatusTime ? dayjs(parseInt(orderData.vendorStatus?.data?.simStatusTime)).format('DD-MMM-YYYY') : "N/A"}
                    />
                  </div>
                  {/* <Form.Item label="Order ID">
                
                    <Input 
                      value={orderData.vendorStatus?.data?.simStatus ? simStatusJoytel[orderData.vendorStatus?.data?.simStatus.toString()] : "N/A"} 
                      disabled
                    />
                  </Form.Item> */}
                </Col>
                <Col span={12}>
                  <Row gutter={8} style={{ marginBottom: 16, alignItems: 'center' }} >
                    <Col span={8}>
                      <Title level={5} style={{ margin: 0, paddingBottom: 8 }}>Recharge Info</Title></Col>
                    {orderData.autoRecharge?.code == 4 && (
                      <Col span={8}>
                        <Button type="text" style={{ color: "red" }} onClick={() => setShowErrorModal(true)}>
                          View Error
                        </Button></Col>
                    )}
                  </Row>
                  {showErrorModal && (
                    <Col span={12}>
                      <Modal
                        title="Recharge Error"
                        open={showErrorModal}
                        onCancel={() => setShowErrorModal(false)}
                        width={400}
                      >
                        <p>{orderData.autoRecharge?.message}</p>
                      </Modal>
                    </Col>
                  )}
                  {hasRechargeData ? (
                    <>
                      <div style={{ marginBottom: 12 }}>
                        <Alert
                          message={isRechargeSuccess ? "Recharge Success" : "Recharge Failed"}
                          type={isRechargeSuccess ? "success" : "error"}
                          showIcon
                        />
                      </div>
                      {Array.isArray(orderData.autoRecharge) ? (
                        <div style={{ maxHeight: "280px", overflowY: "auto", paddingRight: "4px" }}>
                          {orderData.autoRecharge.map((attempt: any, idx: number) => {
                            const isElite = orderData.sku.startsWith('elite');
                            const attemptSuccess = isElite
                              ? (attempt.Status == 1 || attempt.status == 1)
                              : (attempt.message === "SUCCESS" || attempt.code === 0 || attempt.code === "0" || attempt.Message === "SUCCESS");
                            return (
                              <Card
                                key={idx}
                                size="small"
                                title={`Attempt #${idx + 1}`}
                                style={{ marginBottom: 8, border: "1px solid #f0f0f0", borderRadius: "6px" }}
                                extra={
                                  <Tag color={attemptSuccess ? "green" : "red"}>
                                    {attemptSuccess ? "Success" : "Failed"}
                                  </Tag>
                                }
                              >
                                {isElite ? (
                                  <>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>Status: </Text>
                                      <Text strong style={{ fontSize: "12px" }}>{attempt.Status ?? attempt.status ?? "N/A"}</Text>
                                    </div>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>Message: </Text>
                                      <Text style={{ fontSize: "12px" }}>{attempt.Message ?? attempt.message ?? "N/A"}</Text>
                                    </div>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>Processed on: </Text>
                                      <Text style={{ fontSize: "12px" }}>{attempt.rechargeTime ?? attempt.RechargeTime ?? "N/A"}</Text>
                                    </div>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>Processed By: </Text>
                                      <Text style={{ fontSize: "12px" }}>{attempt.rechargeBy ?? attempt.ProcessedBy ?? "N/A"}</Text>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>Code: </Text>
                                      <Text strong style={{ fontSize: "12px" }}>{attempt.code ?? "N/A"}</Text>
                                    </div>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>Message: </Text>
                                      <Text style={{ fontSize: "12px" }}>{attempt.message ?? "N/A"}</Text>
                                    </div>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>rspOrder ID: </Text>
                                      <Text style={{ fontSize: "12px" }}>{attempt.data?.rspOrderId ?? attempt.rspOrderId ?? "N/A"}</Text>
                                    </div>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>order Tid: </Text>
                                      <Text style={{ fontSize: "12px" }}>{attempt.data?.orderTid ?? attempt.orderTid ?? "N/A"}</Text>
                                    </div>
                                    <div style={{ marginBottom: 4 }}>
                                      <Text type="secondary" style={{ fontSize: "12px" }}>Recharge Code: </Text>
                                      <Text style={{ fontSize: "12px" }}>{attempt.data?.rechargeCode ?? attempt.rechargeCode ?? "N/A"}</Text>
                                    </div>
                                  </>
                                )}
                              </Card>
                            );
                          })}
                        </div>
                      ) : (
                        orderData.sku.startsWith('elite') ? (
                          <>
                            <div style={{ marginBottom: 8 }}>
                              <Input
                                readOnly
                                addonBefore="Status"
                                value={(orderData.autoRecharge as any)?.Status || (orderData.autoRecharge as any)?.status || "N/A"}
                              />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <Input
                                readOnly
                                addonBefore="Message"
                                value={(orderData.autoRecharge as any)?.Message || (orderData.autoRecharge as any)?.message || "N/A"}
                              />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <Input
                                readOnly
                                addonBefore="Recharge Processed on"
                                value={(orderData.autoRecharge as any)?.RechargeTime || (orderData.autoRecharge as any)?.rechargeTime || "N/A"}
                              />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <Input
                                readOnly
                                addonBefore="Recharge Processed By"
                                value={(orderData.autoRecharge as any)?.ProcessedBy || (orderData.autoRecharge as any)?.rechargeBy || "N/A"}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{ marginBottom: 8 }}>
                              <Input
                                readOnly
                                addonBefore="rspOrder ID"
                                value={orderData.autoRecharge?.data?.rspOrderId || "N/A"}
                              />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <Input
                                readOnly
                                addonBefore="order Tid"
                                value={orderData.autoRecharge?.data?.orderTid || orderData.orderTid || "N/A"}
                              />
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <Input
                                readOnly
                                addonBefore="Recharge Code"
                                value={orderData.autoRecharge?.data?.rechargeCode || "N/A"}
                              />
                            </div>
                          </>
                        )
                      )}
                    </>
                  ) : (
                    <div style={{ padding: "8px 0" }}>
                      <Text type="secondary">No recharge information available.</Text>
                    </div>
                  )}
                </Col>
              </Row>)}
            </Form>
          </Card>
         
          {orderData.usageData && (
            <Card key={orderData.OrderNumber} style={{ marginBottom: 16 }} title="Data Usage">
              {orderData.usageData.code !== "000" ? (
                <Empty description="No Usage Data available" />
              ) : (
                <>
                  <Row gutter={16} style={{ marginBottom: 12 }}>
                    <Col span={8}>
                      <Input readOnly addonBefore="Total Usage" value={formatUsage(parseInt(orderData.usageData.data.totalUsage), "GB")} />
                    </Col>
                    <Col span={8}>
                      <Input readOnly addonBefore="Effective Time" value={dayjs(parseInt(orderData.usageData.data.effTime)).format('DD-MMM-YYYY HH:mm:ss')} />
                    </Col>
                    <Col span={8}>
                      <Input readOnly addonBefore="Expiry Time" value={dayjs(parseInt(orderData.usageData.data.expTime)).format('DD-MMM-YYYY HH:mm:ss')} />
                    </Col>
                  </Row>
                  <Table
                    size="small"
                    bordered
                    pagination={false}
                    dataSource={orderData.usageData.data.dataUsageList}
                    rowKey={(r) => `${r.usageDate}-${r.mnc}-${r.mcc}`}
                    columns={[
                      { title: 'Date', dataIndex: 'usageDate', render: (v) => dayjs(v, 'YYYYMMDD').format('DD-MMM-YYYY') },
                      { title: 'Usage (bytes)', dataIndex: 'usage', render: (v) => formatUsage(parseInt(v), "MB") },
                    ]}
                  />
                </>
              )}
            </Card>
          )}
           {renderKycDetails()}

        </div>
      </div>
    );
  }


  const renderMappingInfo = () => {
    if(isProcessingOrderDetail) return <LoadingOutlined />
    

    if (mappingDetail?.mapping){
    const mapping = mappingDetail.mapping
    return (
      <div>
        <div style={{ maxHeight: '600px', overflow: 'auto' }}>
          <Card
            key={orderData?.OrderNumber}
            style={{ marginBottom: 12 }}
          >
            <Form layout="vertical">
              <Row gutter={16}>
                <Col span={12}>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Internal Sku" value={mapping.InternalSku ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Vendor ID" value={mapping.VendorId ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="SKU Name" value={mapping.skuName ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Country" value={mapping.country ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Network Name" value={mapping.networkName ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Created At" value={mapping.createdAt ? dayjs(mapping.createdAt).format('DD-MMM-YYYY HH:mm:ss') : "N/A"} />
                  </div>
                </Col>
                <Col span={12}>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Data Plan" value={mapping.dataPlan ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Talk Time" value={mapping.talkTime ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Bundle Value" value={mapping.bundleValue ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Top Up Value" value={mapping.topUpValue ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Bundle Product Code" value={mapping.bundleProductCode ?? "N/A"} />
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Input readOnly addonBefore="Updated At" value={mapping.updatedAt ? dayjs(mapping.updatedAt).format('DD-MMM-YYYY HH:mm:ss') : "N/A"} />
                  </div>
                </Col>
              </Row>
            </Form>
          </Card>
        </div>
      </div>
    );
  }
  else{
  
      return (
        <Empty description="No Mapping found" />
      )
   
  }
  }

  const handleFormChange = (field: string, value: any) => {
    if (field === 'activationDate' && value) {
      const parsedDate = dayjs(value);
      value = parsedDate.isValid() ? parsedDate : null;
    }

    setFormData((prev: any) => ({
      ...prev,
      [field]: value
    }));
  };

  const renderProductDetails = () => {
    if (!orderData || !orderData.productDetails || orderData.productDetails.length === 0) {
      return <Empty description="No product details available" />;
    }

    return (
      <div>
        <div style={{ maxHeight: '600px', overflow: 'auto' }}>
          <Card
            key={orderData.OrderNumber}
            style={{ marginBottom: 16 }}
          >
            <Form layout="vertical">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="ICCID">
                    <Input
                      value={formData?.iccid}
                      onChange={(e) => handleFormChange('iccid', e.target.value)}
                      // disabled={!editMode || !isFieldEditable('iccid', orderData.status)}
                      readOnly
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Mobile Number">
                    <Input
                      value={formData?.mobileNumber}
                      onChange={(e) => handleFormChange('mobileNumber', e.target.value)}
                      // disabled={!editMode || !isFieldEditable('mobileNumber', orderData.status)}
                      readOnly

                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Product Type">
                    <Select
                      value={formData?.type}
                      onChange={(value) => handleFormChange('type', value)}
                      disabled={!editMode || !isFieldEditable('productType', orderData.status)}
                      options={productTypesOptions}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Plan Name">
                    <Select
                      value={formData?.sku}
                      onChange={(value) => handleFormChange('sku', value)}
                      disabled={!editMode || !isFieldEditable('sku', orderData.status)}
                      options={productPlansOptions}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Status">
                    <Select
                      defaultValue={fromUSimStatus(orderData.status)}
                      value={fromUSimStatus(formData?.status)}
                      onChange={(value) => handleFormChange('status', value)}
                      disabled={!editMode || !isFieldEditable('status', orderData.status)}
                      options={USimStatusOptions}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Activation Date">
                    <DatePicker
                      value={formData?.activationDate || null}
                      onChange={(value) => handleFormChange('activationDate', value)}
                      disabled={!editMode || !isFieldEditable('activationDate', orderData.status)}
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Card>
        </div>
      </div>
    );
  };

  const renderUpdatesTab = () => {
    if (!orderData) return <Empty description="No order data available" />;

    const updates: UpdateLogItem[] = orderData.updates || [];

    if (updates.length === 0) {
      return <Empty description="No update history yet" />;
    }

    const sorted = [...updates].sort(
      (a, b) => dayjs(b.updated_at).valueOf() - dayjs(a.updated_at).valueOf()
    );

    return (
      <div style={{ maxHeight: '600px', overflowY: 'auto', paddingRight: 4 }}>
        <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 12 }}>
          <Text strong >
            Total Updates: {sorted.length}
          </Text>
        </div>
        {sorted.map((entry, idx) => {
          const hasData = entry.data && Object.keys(entry.data).length > 0;
          return (
            <div
              key={idx}
              style={{
                display: 'flex',
                gap: 12,
                marginBottom: 12,
              }}
            >


              {/* Card */}
              <Card
                size="small"
                style={{ flex: 1, marginBottom: 0, borderColor: '#f0f0f0' }}
                bodyStyle={{ padding: '8px 12px' }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: hasData ? 8 : 0 }}>
                  <Text strong style={{ fontSize: 13 }}>
                    {dayjs(entry.updated_at).format('DD MMM YYYY, HH:mm:ss')}
                  </Text>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    <strong>Updated By: </strong> {entry.user || 'system'}
                  </Text>
                </div>

                {hasData ? (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {Object.entries(entry.data!).map(([key, val]) => (
                      <div
                        key={key}
                        style={{
                          background: '#f5f5f5',
                          borderRadius: 4,
                          padding: '2px 8px',
                          fontSize: 12,
                          color: '#555',
                          display: 'inline-flex',
                          gap: 4,
                        }}
                      >
                        <span style={{ fontWeight: 600, color: '#333' }}>{key}:</span>
                        <span>{String(val ?? '—')}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <Text type="secondary" style={{ fontSize: 12 }}>No changes recorded</Text>
                )}
              </Card>
            </div>
          );
        })}
      </div>
    );
  };

  const renderCancelTab = () => {
    if (!orderData) return <Empty description="No order data available" />;

    const isOrderCancellable = !NON_CANCELLABLE_STATUSES.includes(orderData.status.toUpperCase());
    const isOrderCancelled = orderData.status.toUpperCase() === 'CANCELLED';

    return (
      <div style={{ textAlign: 'center', padding: '32px' }}>
        {!isOrderCancellable && (
          <Alert
            message="Order Cannot Be Cancelled"
            description={`Orders with status "${orderData.status}" cannot be cancelled.`}
            type="warning"
            showIcon
            icon={<WarningOutlined />}
            style={{ marginBottom: 24 }}
          />
        )}
        {isOrderCancelled && (
          <Alert
            message="Order Already Cancelled"
            description="This order has already been cancelled."
            type="info"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}
        <Row gutter={24}>
          <Col  style={{ marginBottom: 16 }}>
            <Text strong>Order Number: {orderData.OrderNumber} </Text>
          </Col>
          <Col>
           <Text>ICCID: {orderData.iccid}</Text>
            </Col>
            <Col>
            <Text>Mobile Number: {orderData.mobileNumber}</Text></Col>
            <Col>
             <Button
          type="primary"
          danger
          size="large"
          onClick={() => { setCancelAction("cancel"); setShowCancelConfirm(true); }}
          disabled={!isOrderCancellable || isOrderCancelled || isCancelling}
          loading={isCancelling}
          icon={<ExclamationCircleOutlined />}
        >
          Cancel Product
        </Button>
            </Col>
        </Row>

        <Button
        style={{marginTop:24}}
          type="primary"
          danger
          size="large"
          onClick={() => { setCancelAction("cancelAll"); setShowCancelConfirm(true); }}
          disabled={!isOrderCancellable || isOrderCancelled || isCancelling}
          loading={isCancelling}
          icon={<ExclamationCircleOutlined />}
        >
         Cancel Complete Order (all products)
        </Button>
      </div>
    );
  };

  const tabItems = [
    {
      key: "orderDetails",
      label: "Order Details",
      children: renderOrderDetails(),
    },
    {
      key: "productDetails",
      label: "Product Details",
      children: renderProductDetails(),
    },
    {
      key: "Recharge Info",
      label: "Status Page",
      children: renderRechargeInfo(),
    },
    {
      key: "mapping",
      label: "Mapping Info",
      children: renderMappingInfo(),
    },
    {
      key: "updates",
      label: "Logs",
      children: renderUpdatesTab(),
    },
    {
      key: "cancel",
      label: "Cancel Order",
      children: renderCancelTab(),
    }
  ];

  return (
    <>
      <Modal
        title="Order Details"
        open={isVisible}
        onCancel={onClose}
        footer={
          <Space>
            {/* {currentTab === "productDetails" && (
              <>
                {!editMode ? (
                  <Button type="primary" onClick={handleEditOrder}>
                    Edit Order
                  </Button>
                ) : (
                  <Button type="primary" onClick={handleUpdateOrder}>
                    Update Order
                  </Button>
                )}
              </>
            )} */}
            <Button onClick={onClose}>Close</Button>
          </Space>
        }
        width={1000}
      >
        <Tabs
          items={tabItems}
          defaultActiveKey="orderDetails"
          onChange={(key) => setCurrentTab(key)}
        />
      </Modal>

      <Modal
        title="Confirm Order Cancellation"
        open={showCancelConfirm}
        onCancel={() => setShowCancelConfirm(false)}
        onOk={handleCancelOrder}
        okText="Yes, Cancel Order"
        cancelText="No, Keep Order"
        okButtonProps={{ danger: true, loading: isCancelling }}
      >
        <p>Are you sure you want to cancel this order?</p>
        <p>Order Number: {orderData?.OrderNumber}</p>
        <p> {cancelAction == "cancel" ? <> <span>ICCID:{orderData?.iccid}</span></> : null}</p>
        <p>This action cannot be undone.</p>
        {cancelAction === "cancelAll" && (
          <p style={{color: "red"}}>All products in this order will be cancelled</p>
        )}
      </Modal>

      <Modal
        title="Update Status"
        open={isUpdateModalVisible}
        onCancel={() => setIsUpdateModalVisible(false)}
        onOk={handleStatusUpdate}
        okButtonProps={{ loading: isUpdating }}
      >
        <Form layout="horizontal" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
          <Form.Item label="Product Info">
            <Input.TextArea
              rows={2}
              value={selectedProduct ? `ICCID: ${selectedProduct.iccid}\nMobile: ${selectedProduct.mobileNumber}` : ''}
              disabled
            />
          </Form.Item>
          <Form.Item label="Activation Date">
            <DatePicker
              style={{ width: "100%" }}
              value={updateActivationDate}
              
              onChange={(d) => setUpdateActivationDate(d)}
            />
          </Form.Item>
            <Form.Item label="Status">
                <Select
                  value={updateStatus}
                  onChange={(value) => setUpdateStatus(value)}
                  options={statusOptions}
                />
              </Form.Item>
          <Form.Item label="Description">
            <Input.TextArea
              rows={3}
              value={updateDescription}
              onChange={(e) => setUpdateDescription(e.target.value)}
              placeholder="Enter description (optional)"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}